export default [
  {
    path: '/summary/total-bet',
    name: 'total-bet',
    component: () => import('@/views/summary/TotalBet.vue'),
    meta: {
      resource: 'summary',
      action: ['read', 'update'],
      pageTitle: 'Total Bet',
      breadcrumb: [
        {
          text: 'Total Bet',
          active: true,
        },
      ],
    },
  },
  {
    path: '/summary/total-pay',
    name: 'total-pay',
    component: () => import('@/views/summary/TotalPay.vue'),
    meta: {
      resource: 'summary',
      action: ['read', 'update'],
      pageTitle: 'Total Pay',
      breadcrumb: [
        {
          text: 'Total Pay',
          active: true,
        },
      ],
    },
  }, {
    path: '/summary/total-profit',
    name: 'total-profit',
    component: () => import('@/views/summary/TotalProfit.vue'),
    meta: {
      resource: 'summary',
      action: ['read', 'update'],
      pageTitle: 'Total Profit',
      breadcrumb: [
        {
          text: 'Total Profit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/summary/total-poy',
    name: 'total-poy',
    component: () => import('@/views/summary/TotalPoy.vue'),
    meta: {
      resource: 'summary',
      action: ['read', 'update'],
      pageTitle: 'Total Poy',
      breadcrumb: [
        {
          text: 'Total Poy',
          active: true,
        },
      ],
    },
  },
  {
    path: '/summary/betNumber',
    name: 'bet-number',
    component: () => import('@/views/summary/BetNumber.vue'),
    meta: {
      resource: 'summary',
      action: ['read', 'update'],
      pageTitle: 'Bet Number',
      breadcrumb: [
        {
          text: 'Bet Number',
          active: true,
        },
      ],
    },
  },

]
